(() => {
  const init = (root) => {
    if (!root || root.dataset.ssbReady === '1') return;
    root.dataset.ssbReady = '1';

    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const countUp = root.dataset.countUp !== '0';
    const reveals = root.querySelectorAll('[data-ssb-reveal]');
    const nums = root.querySelectorAll('[data-ssb-num]');

    nums.forEach((el) => {
      if (!el.dataset.target) el.dataset.target = el.textContent.trim();
      if (!reduce && countUp) el.textContent = '0';
    });

    if (reduce || !countUp) {
      reveals.forEach((el) => el.classList.add('is-visible'));
      return;
    }

    const animateNumber = (el, from, to, duration) => {
      const start = performance.now();
      const decimals = ((el.dataset.target || '').split('.')[1] || '').length;
      const tick = (now) => {
        const p = Math.min((now - start) / duration, 1);
        const eased = 1 - Math.pow(1 - p, 3);
        const value = from + (to - from) * eased;
        el.textContent = value.toFixed(decimals);
        if (p < 1) requestAnimationFrame(tick);
        else el.textContent = Number(to).toFixed(decimals);
      };
      requestAnimationFrame(tick);
    };

    const setRevealed = (on) => {
      reveals.forEach((el) => {
        const was = el.classList.contains('is-visible');
        el.classList.toggle('is-visible', on);
        if (on && !was) {
          el.querySelectorAll('[data-ssb-num]').forEach((numEl) => {
            const target = parseFloat(numEl.dataset.target || '0');
            animateNumber(numEl, parseFloat(numEl.textContent) || 0, target, 700);
          });
        } else if (!on && was) {
          el.querySelectorAll('[data-ssb-num]').forEach((numEl) => {
            animateNumber(numEl, parseFloat(numEl.textContent) || 0, 0, 280);
          });
        }
      });
    };

    const update = () => {
      const rect = root.getBoundingClientRect();
      const vh = window.innerHeight || 1;
      const visibleTop = Math.max(rect.top, 0);
      const visibleBottom = Math.min(rect.bottom, vh);
      const visibleH = Math.max(0, visibleBottom - visibleTop);
      const ratio = Math.min(Math.max(visibleH / Math.min(rect.height, vh), 0), 1);
      setRevealed(ratio > 0.55 && rect.top < vh * 0.92);
    };

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();

    root.addEventListener(
      'shopify:section:unload',
      () => {
        window.removeEventListener('scroll', update);
        window.removeEventListener('resize', update);
      },
      { once: true }
    );
  };

  const boot = () => document.querySelectorAll('[data-ssb-root]').forEach(init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('[data-ssb-root]');
    if (root) {
      delete root.dataset.ssbReady;
      init(root);
    }
  });
})();
